import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import Register from './views/Register.vue';
import Otp from './views/Otp.vue';
import AllReborer from './views/Partners/Reborer/AllReborer'
import AllReborerDeleted from './views/Partners/Reborer/AllReborerDeleted'
import AllDealers from './views/Dealers.vue'
import BrandDashboard from './views/BrandDashboard.vue'
import Page404 from './views/Page404.vue'
import PasswordReset from './views/PasswordReset/PasswordReset.vue'
import PasswordResettakeEmail from './views/PasswordReset/takeEmail.vue'
import PasswordResetSetPassword from './views/PasswordReset/PasswordResetSetPassword.vue'
Vue.use(Router);

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect:{
        name: 'login'
      }
    },
    {
      path: '/passwordReset',
      component: PasswordReset,
      children: [
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: 'takeEmail',
          component: PasswordResettakeEmail
        },
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: 'setNewPassword',
          component: PasswordResetSetPassword
        },
      ]
    },
    {
      path: '/home',
      component: Home
    },
    {
      path: '/login',
      name:'login',
      component: Login
    },
    {
      path: '/otp',
      name:'otp',
      component: Otp
    },
    {
      path: '/admin',
      name: 'admin',
      component: BrandDashboard,
    },
    {
      path: '/allServicePartners',
      name: 'allServicePartners',
      component: () => import(/* webpackChunkName: "Service-partner" */ './views/Partners/AllServicePartners/AllServicePartners.vue')
    },
    {
      path: '/allServicePartnersDeleted',
      name: 'allServicePartnersDeleted',
      component: () => import(/* webpackChunkName: "Service-partner" */ './views/Partners/AllServicePartners/AllServicePartnersDeleted.vue')
    },
    {
      path: '/allReborer',
      name: 'allReborer',
      component: AllReborer,
    },
    {
      path: '/allReborerDeleted',
      name: 'allReborerDeleted',
      component: AllReborerDeleted,
    },
    { 
      path: '/editReborer/:partner_id',
      props: true,
      name:'editReborer',
      component: () => import('./views/Partners/Reborer/EditReborer.vue')
    },
    {
      path: '/addReborer',
      name: 'addReborer',
      // lazy-loaded
      component: () => import('./views/AddReborer.vue')
    },
    {
      path: '/allMechanic',
      name: 'allMechanic',
      component: () => import(/* webpackChunkName: "Service-partner" */ './views/Partners/Mechanic/AllMechanic.vue')
    },
    {
      path: '/allMechanicDeleted',
      name: 'allMechanicDeleted',
      component: () => import(/* webpackChunkName: "Service-partner" */ './views/Partners/Mechanic/AllMechanicDeleted')
    },
    { 
      path: '/editMechanic/:partner_id',
      props: true,
      name:'editMechanic',
      component: () => import(/* webpackChunkName: "Service-partner" */ './views/Partners/Mechanic/EditMechanic.vue')
    },
    {
      path: '/allGrinder',
      name: 'allGrinder',
      component: () => import(/* webpackChunkName: "Service-partner" */ './views/Partners/Grinder/AllGrinder.vue')
    },
    {
      path: '/allGrinderDeleted',
      name: 'allGrinderDeleted',
      component: () => import(/* webpackChunkName: "Service-partner" */ './views/Partners/Grinder/AllGrinderDeleted')
    },
    { 
      path: '/editGrinder/:partner_id',
      props: true,
      name:'editGrinder',
      component: () => import(/* webpackChunkName: "Service-partner" */ './views/Partners/Grinder/EditGrinder.vue')
    },
    {
      path: '/allGrinderReborer',
      name: 'allGrinderReborer',
      component: () => import(/* webpackChunkName: "Service-partner" */ './views/Partners/GrinderReborer/AllGrinderReborer.vue')
    },
    {
      path: '/allGrinderReborerDeleted',
      name: 'allGrinderReborerDeleted',
      component: () => import(/* webpackChunkName: "Service-partner" */ './views/Partners/GrinderReborer/AllGrinderReborerDeleted.vue')
    },
    { 
      path: '/editGrinderReborer/:partner_id',
      props: true,
      name:'editGrinderReborer',
      component: () => import(/* webpackChunkName: "Service-partner" */ './views/Partners/GrinderReborer/EditGrinderReborer.vue')
    },
    {
      path: '/allDistributor',
      name: 'allDistributor',
      component: () => import(/* webpackChunkName: "Channel-partner" */ './views/Partners/Distributor/AllDistributor.vue')
    },
    {
      path: '/allDistributorDeleted',
      name: 'allDistributorDeleted',
      component: () => import(/* webpackChunkName: "Channel-partner" */ './views/Partners/Distributor/AllDistributorDeleted.vue')
    },
    { 
      path: '/editDistributor/:partner_id',
      props: true,
      name:'editDistributor',
      component: () => import(/* webpackChunkName: "Channel-partner" */ './views/Partners/Distributor/EditDistributor.vue')
    },
    {
      path: '/allRetailer',
      name: 'allRetailer',
      component: () => import(/* webpackChunkName: "Channel-partner" */ './views/Partners/Retailer/AllRetailer.vue')
    },
    {
      path: '/allRetailerDeleted',
      name: 'allRetailerDeleted',
      component: () => import(/* webpackChunkName: "Channel-partner" */ './views/Partners/Retailer/AllRetailerDeleted.vue')
    },
    { 
      path: '/editRetailer/:partner_id',
      props: true,
      name:'editRetailer',
      component: () => import(/* webpackChunkName: "Channel-partner" */ './views/Partners/Retailer/EditRetailer.vue')
    },
    {
      path: '/dealers',
      name: 'dealers',
      component: AllDealers,
    },
    
    {
      path: '/generateCoupons',
      name: 'generateCoupons',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "Coupon" */ './views/Coupons/GenerateCoupons.vue')
    },
    {
      path: '/printCoupons',
      name: 'printCoupons',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "Coupon" */ './views/Coupons/PrintCoupons.vue')
    },
    {
      path: '/PrintCouponsDeleteArchive',
      name: 'PrintCouponsDeleteArchive',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "Coupon" */ './views/Coupons/PrintCouponsDeleteArchive.vue')
    },
    {
      path: '/batchCreate',
      name: 'batchCreate',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "Coupon" */ './views/Coupons/BatchCreate.vue')
    },
    {
      path: '/couponMaster',
      name: 'couponMaster',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "Coupon" */ './views/Coupons/CouponMaster.vue')
    },
    {
      path: '/productCouponsDetails',
      name: 'productCouponsDetails',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "Coupon" */ './views/Coupons/ProductCouponDetails.vue')
    },
    
    {
      path: '/addProduct',
      name: 'addProduct',
      // lazy-loaded
      component: () => import('./views/AddProduct.vue')
    },
    {
      path: '/productMaster',
      name: 'productMaster',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "product-Master" */ './views/product/ProductMaster.vue')
    },
    {
      path: '/productMasterDeleted',
      name: 'productMasterDeleted',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "product-Master" */ './views/product/ProductMasterDeleted.vue')
    },
    { 
      path: '/customerAccumulationPart',
      name:'customerAccumulationPart',
      component: () => import('./views/reports/CustomerAccumulationPart.vue')
    },
    { 
      path: '/CustomerAccumulationByPartSegment',
      name:'CustomerAccumulationByPartSegment',
      component: () => import('./views/reports/CustomerAccumulationByPartSegment.vue')
    },
    {
      path: '/enquiry',
      name: 'enquiry',
      // lazy-loaded
      component: () => import('./views/AddEnquery.vue')
    },
    {
      path: '/enqueryList',
      name: 'enqueryList',
      // lazy-loaded
      component: () => import('./views/EnqueryList.vue')
    },
    {
      path: '/organisationProfile',
      name: 'organisationProfile',
      component: () => import('./views/OrgProfile.vue')
    },
    {
      path: '/scanCouponDetails',
      name: 'scanCouponDetails',
      component: () => import('./views/ScanCouponDetails.vue')
    },
    {
      path: '/redeemptionCouponDetails',
      name: 'redeemptionCouponDetails',
      component: () => import('./views/RedeemptionCouponDetails.vue')
    },
    {
      path: '/sacnnerDashboard',
      name: 'sacnnerDashboard',
      component: () => import('./views/sacnnerDashboard.vue')
    },
    {
      path: '/register',
      component: Register
    },
    {
      path: '/profile',
      name: 'profile',
      // lazy-loaded
      component: () => import('./views/Profile.vue')
    },
    {
      path: '/user',
      name: 'user',
      // lazy-loaded
      component: () => import('./views/BoardUser.vue')
    },
    {
      path: '/RoleAndPermission',
      name: 'RoleAndPermission',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "Role-Perm" */ './views/RoleManagement/RoleAndPermission.vue'),
    },
    { 
      path: '/AddRole',
      name: 'AddRole',
        // lazy-loaded
        component: () => import(/* webpackChunkName: "Role-Perm" */ './views/RoleManagement/AddRole.vue')
    },
    {
      path: '/PartnerRoleAndPermission',
      name: 'PartnerRoleAndPermission',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "Role-Perm" */ './views/RoleManagement/PartnerRoleAndPermission.vue')
    },
    {
      path: '/orgEmployees',
      name: 'orgEmployees',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "Employee" */ './views/Employees/OrgEmployees.vue')
    },
    { 
      path: '/editEmployees/:id',
      props: true,
      name:'editEmployees',
      component: () => import('./views/EditEmployee.vue')
    },
    {
      path: '/OrgEmployeesDeleteList',
      name: 'OrgEmployeesDeleteList',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "Employee" */'./views/Employees/OrgEmployeesDeleteList.vue')
    },
    {
      path: '/addEmployee',
      name: 'addEmployee',
      // lazy-loaded
      component: () => import(/* webpackChunkName: "Employee" */'./views/AddEmployee.vue')
    },
    {
      path: '/redeemptionRequestList',
      name: 'redeemptionRequestList',
      // lazy-loaded
      component: () => import('./views/RedeemptionRequestList.vue')
    },
    {
      path: '/paymentOperations',
      name: 'paymentOperations',
      // lazy-loaded
      component: () => import('./views/payment/paymentOperations.vue')
    },
    {
      path: '/paymentExportFileLog',
      name: 'paymentExportFileLog',
      // lazy-loaded
      component: () => import('./views/payment/paymentExportFileLog.vue')
    },
    {
      path: '/paymentImportFileLog',
      name: 'paymentImportFileLog',
      // lazy-loaded
      component: () => import('./views/payment/paymentImportFileLog.vue')
    },
    {
      path: '/printCouponsLog',
      name: 'printCouponsLog',
      // lazy-loaded
      component: () => import('./views/loyaltyPrintFileLog.vue')
    },
    {
      path: '/reportProductCouponsDetails',
      name: 'reportProductCouponsDetails',
      // lazy-loaded
      component: () => import('./views/reports/ProductCouponDetails.vue')
    },
    {
      path: '/reportRedeemptionCouponDetails',
      name: 'reportRedeemptionCouponDetails',
      // lazy-loaded
      component: () => import('./views/reports/RedeemptionCouponDetails.vue')
    },
    {
      path: '/reportAllPartnerPointBalance',
      name: 'reportAllPartnerPointBalance',
      // lazy-loaded
      component: () => import('./views/reports/AllPartnerPointBalance.vue')
    },
    {
      path: '/Report/coupons',
      name: 'couponsReport',
      // lazy-loaded
      component: () => import('./views/reports/Coupons.vue')
    },
    {
      path: '/Report/couponsScan',
      name: 'couponsScanReport', // changed from 'couponsReport' to 'couponsScanReport'
      // lazy-loaded
      component: () => import('./views/reports/CouponsScan.vue')
    },
    {
      path: '/reportInvalidCoupons',
      name: 'reportInvalidCoupons',
      component: () => import('./views/reports/InvalidCoupons.vue')
    },
   
    {
      path: '/editUserType/:email',
      props: true,
      name: 'editUserType',
      // lazy-loaded
      component: () => import('./views/editUserType.vue')
    },
    {
 // will match everything
      path: '*',
     component:Page404
    }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register', '/home','/otp','/enquiry','/passwordReset/takeEmail','/passwordReset/setNewPassword'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login');
  } else {
    next();
  }
});
